 $(document).ready(function() {
    $(".demoColor-name").hover(function () {
      //alert("hii");
     var colorName= $(this).data('color');
      //$(parents('.color-name')).find('p').html(colorName);
      $(".color-name p").html(colorName); 
    }, function() {
          $(".color-name p").html(); 
    });
});  